"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = exports.SmartSwiper = exports.swiperAria = exports.SlideTypeEnum = exports.StyledModalImageSwiper = exports.StyledImageSwiper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactUsestateref = _interopRequireDefault(require("react-usestateref"));

var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _swiper = _interopRequireWildcard(require("swiper"));

var _react2 = require("swiper/react");

require("swiper/swiper-bundle.min.css");

var _styled = _interopRequireDefault(require("@material-ui/core/styles/styled"));

var _styles = require("../swiper/styles");

var _Zoom = _interopRequireDefault(require("../swiper/assets/Zoom.svg"));

var _Slides = require("./Slides");

var _YoutubePlay = require("./YoutubePlay");

var _panzoom = _interopRequireDefault(require("@panzoom/panzoom"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

_swiper.default.use([_swiper.Navigation, _swiper.Pagination, _swiper.Scrollbar, _swiper.A11y, _swiper.Thumbs, _swiper.Keyboard, _swiper.Mousewheel, _swiper.Zoom, _swiper.Lazy]);

var RefSwiper = _react2.Swiper;
var StyledImageSwiper = (0, _styled.default)(_styles.StyledSwiper)({
  height: 'calc(100% - 100px)'
});
exports.StyledImageSwiper = StyledImageSwiper;
var StyledModalImageSwiper = (0, _styled.default)(_styles.StyledSwiper)(function (_ref) {
  var _swiperButtonPre, _swiperButtonNex;

  var zoomed = _ref.zoomed,
      theme = _ref.theme;
  return {
    height: 'calc(100% - 100px)',
    '& .swiper-slide': {
      display: zoomed ? 'block' : 'flex',
      justifyContent: 'center',
      overflow: 'hidden'
    },
    '& .swiper-container': {
      '& .swiper-button-prev': (_swiperButtonPre = {}, _defineProperty(_swiperButtonPre, theme.breakpoints.down('md'), {
        display: 'inherit'
      }), _defineProperty(_swiperButtonPre, '&::after', {
        display: 'none'
      }), _swiperButtonPre),
      '& .swiper-button-next': (_swiperButtonNex = {}, _defineProperty(_swiperButtonNex, theme.breakpoints.down('md'), {
        display: 'inherit'
      }), _defineProperty(_swiperButtonNex, '&::after', {
        display: 'none'
      }), _swiperButtonNex)
    }
  };
});
exports.StyledModalImageSwiper = StyledModalImageSwiper;
var breakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 1,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 1,
    spaceBetween: 10
  }
};
var thumbBreakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 4,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 10,
    spaceBetween: 10
  }
}; // internal slider implementation which we do not expose to users

var SlideTypeEnum = {
  image: 'image',
  youtube: 'youtube'
};
exports.SlideTypeEnum = SlideTypeEnum;

var toSlides = function toSlides(child, index) {
  if (! /*#__PURE__*/_react.default.isValidElement(child)) {
    return null;
  }

  var _child$props = child.props,
      type = _child$props.type,
      url = _child$props.url,
      thumbnail = _child$props.thumbnail,
      thumbnailsProps = _child$props.thumbnailsProps,
      originalSrc = _child$props.originalSrc,
      props = _objectWithoutProperties(_child$props, ["type", "url", "thumbnail", "thumbnailsProps", "originalSrc"]);

  var key = child.key || url || index;
  return {
    type: type === SlideTypeEnum.youtube ? SlideTypeEnum.youtube : SlideTypeEnum.image,
    key: key,
    url: url,
    originalSrc: originalSrc,
    thumbnail: thumbnail || url,
    props: props,
    // set alt from main image to thumbnail
    thumbnailsProps: _objectSpread({
      alt: props.alt
    }, thumbnailsProps)
  };
}; // parse slides definition either from array or from children;
// handles if images are broken


var useSlidesFromChildren = function useSlidesFromChildren(_ref2) {
  var children = _ref2.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      slides = _useState2[0],
      setSlides = _useState2[1];

  var loadedImages = (0, _react.useRef)({});
  var hasThumbnails = (0, _react.useMemo)(function () {
    return slides.some(function (_ref3) {
      var thumbnail = _ref3.thumbnail,
          type = _ref3.type;
      return thumbnail || type === SlideTypeEnum.youtube;
    });
  }, [slides]);
  var onImageError = (0, _react.useCallback)(function (index) {
    return function () {
      // removes the broken image from the array
      setSlides([].concat(_toConsumableArray(slides.slice(0, index)), _toConsumableArray(slides.slice(index + 1))));
    };
  }, [slides]);
  var onImageLoad = (0, _react.useCallback)(function (url) {
    return function () {
      // prevents images from being loaded more than once
      Object.defineProperty(loadedImages.current, url, {
        value: true
      });
    };
  }, [slides]); // maps from Children to Slides

  (0, _react.useLayoutEffect)(function () {
    setSlides(_react.default.Children.map(children, toSlides));
  }, [children]); // image error handling

  (0, _react.useEffect)(function () {
    slides.forEach(function (_ref4, index) {
      var url = _ref4.url,
          type = _ref4.type;

      if (type !== SlideTypeEnum.youtube && !loadedImages.current[url]) {
        var img = new Image();
        img.src = url;
        img.onload = onImageLoad(url);
        img.onerror = onImageError(index);
      }
    });
  }, [slides]);
  return {
    slides: slides,
    hasThumbnails: hasThumbnails
  };
};

function useSmartSwiperData(props) {
  var _useState3 = (0, _react.useState)(function () {
    return function () {};
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      zoomToggle = _useState4[0],
      setZoomToggle = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      thumbsSwiper = _useState6[0],
      setThumbsSwiper = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      hasZoom = _useState8[0],
      setHasZoom = _useState8[1]; // we have to override this props otherwise component will be broken


  var defaultProps = {
    a11y: {
      enable: true
    },
    direction: 'horizontal',
    freeMode: false,
    initialSlide: 0,
    keyboard: true,
    loop: false,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    mousewheel: false,
    noSwiping: false,
    breakpoints: breakpoints,
    centeredSlides: true,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    onAfterInit: function onAfterInit(swiper) {
      return setZoomToggle(function () {
        return swiper.zoom.toggle;
      });
    },
    preloadImages: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 150,
    tag: 'section',
    thumbs: {
      swiper: thumbsSwiper
    },
    wrapperTag: 'ul',
    zoom: {
      toggle: false
    },
    simulateTouch: false,
    allowTouchMove: false
  };
  var defaultThumbProps = {
    breakpoints: thumbBreakpoints,
    tag: 'section',
    wrapperTag: 'ul',
    onSwiper: function onSwiper(swiper) {
      setThumbsSwiper(swiper);
    },
    slidesPerView: 10,
    slidesPerGroup: 1,
    loopFillGroupWithBlank: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    scrollbar: {
      draggable: true
    },
    preloadImages: true,
    speed: 150
  };

  var mergedProps = _objectSpread(_objectSpread({}, defaultProps), props);

  mergedProps.zoom = hasZoom ? mergedProps.zoom : null;
  return {
    thumbProps: defaultThumbProps,
    sliderProps: mergedProps,
    hasZoom: !!mergedProps.zoom,
    setHasZoom: setHasZoom,
    zoomToggle: zoomToggle
  };
}

var swiperAria = {
  prevButton: 'Previous slide',
  nextButton: 'Next slide',
  swiperThumbnailsLabelRoot: 'swiper thumbnails for youtube and images',
  swiperLabelRoot: 'swiper for youtube and images',
  thumbnailAlt: function thumbnailAlt(i) {
    return "slide thumbnail ".concat(i + 1);
  },
  slide: function slide(i) {
    return "slide image ".concat(i + 1);
  }
};
exports.swiperAria = swiperAria;
var swiperTestIds = {
  prevButton: 'swiper/prevButton',
  nextButton: 'swiper/nextButton',
  zoom: 'swiper/zoom',
  modalZoomButton: 'modalSwiper/modalZoomButton',
  modalPrevButton: 'swiper/prevButton',
  modalNextButton: 'swiper/nextButton'
};

var SmartSwiper = function SmartSwiper(_ref5) {
  var children = _ref5.children,
      other = _objectWithoutProperties(_ref5, ["children"]);

  var isMobile = (0, _useMediaQuery.default)(function (theme) {
    return theme.breakpoints.down('sm');
  });

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      currentSlideIndex = _useState10[0],
      setCurrentSlideIndex = _useState10[1];

  var _useSlidesFromChildre = useSlidesFromChildren({
    children: children
  }),
      slides = _useSlidesFromChildre.slides,
      hasThumbnails = _useSlidesFromChildre.hasThumbnails;

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      modalOpen = _useState12[0],
      setModalOpen = _useState12[1];

  var swiperRef = (0, _react.useRef)(null);

  var isYoutube = function isYoutube(slide) {
    return slide.type === SlideTypeEnum.youtube && slide.thumbnail.toString().indexOf('youtube') > -1;
  };

  var handleZoomClick = function handleZoomClick() {
    setModalOpen(true);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !modalOpen && /*#__PURE__*/_react.default.createElement(MainSwiper, {
    swiperRef: swiperRef,
    handleZoomClick: handleZoomClick,
    slides: slides,
    hasThumbnails: hasThumbnails,
    isYoutube: isYoutube,
    currentSlideIndex: currentSlideIndex,
    setCurrentSlideIndex: setCurrentSlideIndex,
    other: other
  }), modalOpen && /*#__PURE__*/_react.default.createElement(SwiperModal, {
    isMobile: isMobile,
    other: other,
    swiperRef: swiperRef,
    slides: slides,
    hasThumbnails: hasThumbnails,
    isYoutube: isYoutube,
    currentSlideIndex: currentSlideIndex,
    setCurrentSlideIndex: setCurrentSlideIndex,
    modalOpen: modalOpen,
    setModalOpen: setModalOpen
  }));
};

exports.SmartSwiper = SmartSwiper;

var MainSwiper = function MainSwiper(_ref6) {
  var other = _ref6.other,
      swiperRef = _ref6.swiperRef,
      handleZoomClick = _ref6.handleZoomClick,
      slides = _ref6.slides,
      hasThumbnails = _ref6.hasThumbnails,
      isYoutube = _ref6.isYoutube,
      setCurrentSlideIndex = _ref6.setCurrentSlideIndex,
      currentSlideIndex = _ref6.currentSlideIndex;

  var _useSmartSwiperData = useSmartSwiperData(other),
      sliderProps = _useSmartSwiperData.sliderProps,
      thumbProps = _useSmartSwiperData.thumbProps;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledImageSwiper, {
    "aria-label": swiperAria.swiperLabelRoot
  }, /*#__PURE__*/_react.default.createElement(RefSwiper, _extends({}, sliderProps, {
    ref: swiperRef,
    initialSlide: currentSlideIndex,
    onSlideChange: function onSlideChange(s) {
      return setCurrentSlideIndex(s.activeIndex);
    }
  }), /*#__PURE__*/_react.default.createElement(SlideNavigators, {
    testIdNext: swiperTestIds.nextButton,
    testIdPrev: swiperTestIds.prevButton
  }), /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": swiperTestIds.zoom,
    onClick: function onClick() {
      return handleZoomClick();
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === '' && handleZoomClick();
    },
    className: "zoom-icon",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Zoom icon",
    src: _Zoom.default
  })), slides.map(function (slide, i) {
    if (slide.type === SlideTypeEnum.youtube) {
      return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
        "aria-label": swiperAria.slide(i),
        key: slide.key,
        tag: "li",
        zoom: true
      }, function (isActiveProps) {
        return /*#__PURE__*/_react.default.createElement(_Slides.YoutubeSlide, _extends({
          setZoom: function setZoom() {},
          isActive: isActiveProps.isActive,
          url: slide.url
        }, slide.props));
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      "aria-label": swiperAria.slide(i),
      key: slide.key,
      tag: "li",
      zoom: true
    }, /*#__PURE__*/_react.default.createElement(_Slides.ImageSlide, _extends({
      alt: swiperAria.slide(i)
    }, slide.props, {
      url: slide.url
    })));
  }))), /*#__PURE__*/_react.default.createElement(BottomSwiper, {
    hasThumbnails: hasThumbnails,
    currentSlideIndex: currentSlideIndex,
    thumbProps: thumbProps,
    slides: slides,
    isYoutube: isYoutube
  }));
};

var SwiperModal = function SwiperModal(_ref7) {
  var _currentSlide$thumbna;

  var other = _ref7.other,
      swiperRef = _ref7.swiperRef,
      slides = _ref7.slides,
      hasThumbnails = _ref7.hasThumbnails,
      isYoutube = _ref7.isYoutube,
      setCurrentSlideIndex = _ref7.setCurrentSlideIndex,
      currentSlideIndex = _ref7.currentSlideIndex,
      modalOpen = _ref7.modalOpen,
      setModalOpen = _ref7.setModalOpen,
      isMobile = _ref7.isMobile;

  var _useSmartSwiperData2 = useSmartSwiperData(other),
      sliderProps = _useSmartSwiperData2.sliderProps,
      thumbProps = _useSmartSwiperData2.thumbProps,
      setHasZoom = _useSmartSwiperData2.setHasZoom;

  var _useStateRef = (0, _reactUsestateref.default)(false),
      _useStateRef2 = _slicedToArray(_useStateRef, 3),
      zoomed = _useStateRef2[0],
      setZoomed = _useStateRef2[1],
      zoomedRef = _useStateRef2[2];

  var handleModalZoomButton = function handleModalZoomButton() {
    return setZoomed(!zoomed);
  };

  var currentSlide = slides === null || slides === void 0 ? void 0 : slides.find(function (s, i) {
    return i === currentSlideIndex;
  });
  var zoomButtonVisible = !isYoutube(currentSlide || {}) && !(currentSlide !== null && currentSlide !== void 0 && (_currentSlide$thumbna = currentSlide.thumbnail) !== null && _currentSlide$thumbna !== void 0 && _currentSlide$thumbna.includes('video'));
  (0, _react.useEffect)(function () {
    setZoomed(false);
  }, [currentSlideIndex]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: modalOpen,
    onClose: function onClose() {
      return setModalOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledModalBody, null, /*#__PURE__*/_react.default.createElement(_styles.StyledCloseIcon, {
    onClick: function onClick() {
      return setModalOpen(false);
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === '' && setModalOpen(false);
    }
  }), zoomButtonVisible && /*#__PURE__*/_react.default.createElement(_styles.StyledZoomButton, {
    onClick: handleModalZoomButton,
    "data-testid": swiperTestIds.modalZoomButton,
    role: "button",
    type: "button",
    "tab-index": "0",
    "aria-pressed": zoomed,
    "aria-label": "Zoom"
  }, zoomed ? 'ZOOM OUT' : 'ZOOM IN'), /*#__PURE__*/_react.default.createElement(StyledModalImageSwiper, {
    zoomed: zoomed,
    "aria-label": swiperAria.swiperLabelRoot
  }, /*#__PURE__*/_react.default.createElement(RefSwiper, _extends({}, sliderProps, {
    ref: swiperRef,
    initialSlide: currentSlideIndex,
    onSlideChange: function onSlideChange(s) {
      return setCurrentSlideIndex(s.activeIndex);
    }
  }), /*#__PURE__*/_react.default.createElement(SlideNavigators, {
    testIdNext: swiperTestIds.modalNextButton,
    testIdPrev: swiperTestIds.modalPrevButton
  }), slides.map(function (slide, i) {
    if (slide.type === SlideTypeEnum.youtube) {
      return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
        "aria-label": swiperAria.slide(i),
        key: slide.key,
        tag: "li"
      }, function (isActiveProps) {
        return /*#__PURE__*/_react.default.createElement(_Slides.YoutubeSlide, _extends({
          setZoom: setHasZoom,
          isActive: isActiveProps.isActive,
          url: slide.url
        }, slide.props));
      });
    }
    /* define the ref inside the .map() so each image gets a unique ref */


    var containerRef = (0, _react.useRef)(null);
    /* allows us to zoom in and pan the image with ease (https://github.com/timmywil/panzoom) */

    (0, _react.useEffect)(function () {
      /* get the zoomed in image */
      var img = containerRef.current;
      /* if the image is not zoomed in, do nothing */

      if (img) {
        var elem = document.getElementById(slide.key);
        /* instantiate the zoom plugin, containing the zoomed in image */

        var panzoom = (0, _panzoom.default)(elem, {
          maxScale: 4,
          minScale: 1
        }); // eslint-disable-next-line func-names

        var wheelZoomHandler = function wheelZoomHandler(e) {
          /* if the user is zoomed in, enable zoom with the mouse wheel */
          if (zoomedRef.current) {
            panzoom.zoomWithWheel(e);
          }
        };
        /* are we zoomed in? */


        if (zoomedRef.current) {
          /* attach a mouse wheel event listener to the image after zoomed in */
          elem.parentElement.addEventListener('wheel', wheelZoomHandler);
          /* are we on a mobile device? */

          if (isMobile) {
            /* zoom to "4" on mobile */
            panzoom.zoom(4, {
              animate: true,
              duration: 300
            });
          } else {
            /* zoom to "2" on desktop */
            panzoom.zoom(2, {
              animate: true,
              duration: 300
            });
          }
        } else {
          /* remove the mouse wheel zoom handler after the user zooms out */
          elem.parentElement.removeEventListener('wheel', wheelZoomHandler);
          /* default zoom */

          panzoom.zoom(1, {
            animate: true,
            duration: 300
          });
        }
      }
    }, [zoomed]); // only run when zoom is enabled

    var display = isMobile ? 'flex' : 'block';
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      "aria-label": swiperAria.slide(i) // @ts-ignore
      ,
      ref: containerRef,
      key: slide.key,
      tag: "li"
      /* we use inline styles here because a styled component did not work */
      ,
      style: {
        display: "".concat(display)
      }
    }, /*#__PURE__*/_react.default.createElement(_styles.StyledImageSlide, _extends({
      isMobile: isMobile,
      zoomed: zoomed,
      alt: swiperAria.slide(i)
    }, slide.props, {
      onClick: null,
      id: slide.key,
      url: slide.originalSrc,
      draggable: "false"
    })));
  }))), /*#__PURE__*/_react.default.createElement(BottomSwiper, {
    hasThumbnails: hasThumbnails,
    currentSlideIndex: currentSlideIndex,
    thumbProps: thumbProps,
    slides: slides,
    isYoutube: isYoutube
  }))));
};

var SlideNavigators = function SlideNavigators(_ref8) {
  var testIdNext = _ref8.testIdNext,
      testIdPrev = _ref8.testIdPrev;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": testIdNext,
    "aria-label": swiperAria.prevButton,
    className: "swiper-button-prev",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, {
    style: {
      fontSize: 40
    }
  })), /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": testIdPrev,
    "aria-label": swiperAria.nextButton,
    className: "swiper-button-next",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, {
    style: {
      fontSize: 40
    }
  })));
};

var BottomSwiper = function BottomSwiper(_ref9) {
  var hasThumbnails = _ref9.hasThumbnails,
      currentSlideIndex = _ref9.currentSlideIndex,
      thumbProps = _ref9.thumbProps,
      slides = _ref9.slides,
      isYoutube = _ref9.isYoutube;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasThumbnails && /*#__PURE__*/_react.default.createElement(_styles.StyledThumbs, {
    "aria-label": swiperAria.swiperThumbnailsLabelRoot
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({}, thumbProps, {
    initialSlide: currentSlideIndex
  }), slides.map(function (slide, i) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: slide.key,
      tag: "li"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "slide-padding",
      "aria-label": swiperAria.thumbnailAlt(i)
    }, isYoutube(slide) ? /*#__PURE__*/_react.default.createElement(_YoutubePlay.YoutubePlay, null) : /*#__PURE__*/_react.default.createElement("img", _extends({
      alt: swiperAria.thumbnailAlt(i)
    }, slide.thumbnailsProps, {
      src: slide.thumbnail
    }))));
  }))));
}; // we use this component to workaround issue with swiper which wants to have SwiperSlide as it's primary children
// we want to have nice jsx api but at the same time have strict api, so we are doing same thing as Swiper.js
// and implement our own Slide representation which is used only for passing props to component
// eslint-disable-next-line no-unused-vars


var Slide = function Slide() {
  throw new Error('should not be rendered'); // eslint-disable-next-line no-unreachable

  return /*#__PURE__*/_react.default.createElement("div", null);
}; // We use compound components here, so we won't have name slashes since slide is quite common name


exports.Slide = Slide;
SmartSwiper.Slide = Slide;